import React, { useState, useContext } from "react";
import { DownOutlined, RightOutlined, LoadingOutlined, EyeOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";

const STATUS_COLORS = {
  open: "default",
  assigned: "purple",
  Assigned: "purple",
  pending: "orange",
  inProgress: "blue",
  completed: "green",
  closed: "cyan",
  cancelled: "red",
};

const formatDate = (dateStr, lang) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "-";
  const months = lang === "ar"
    ? ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
    : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

export default function PreviousServiceHistory({ historyData, historyLoading, historyError, onViewAll, lang }) {
  const [expanded, setExpanded] = useState(false);
  const { showDetails } = useContext(popupcontext);

  if (historyLoading) {
    return (
      <div className="previous-service-history mb-3" style={{
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        padding: "12px 16px",
        background: "#fafafa",
      }}>
        <div className="d-flex align-items-center gap-2">
          <LoadingOutlined />
          <span style={{ color: "#999" }}>{trans("Loading service history...")}</span>
        </div>
      </div>
    );
  }

  if (historyError) {
    return null;
  }

  const requests = historyData?.data || [];
  const total = historyData?.total || 0;

  return (
    <div className="previous-service-history mb-3" style={{
      border: "1px solid #f0f0f0",
      borderRadius: "8px",
      overflow: "hidden",
    }}>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          padding: "10px 16px",
          background: "#fafafa",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setExpanded((v) => !v)}
      >
        <div className="d-flex align-items-center gap-2">
          {expanded ? <DownOutlined style={{ fontSize: "12px" }} /> : <RightOutlined style={{ fontSize: "12px" }} />}
          <span className="fw-500 brand-700" style={{ fontSize: "15px" }}>
            {trans("Previous Service History")} ({total})
          </span>
        </div>
        <span
          role="button"
          className="text-primary"
          style={{ fontSize: "13px", textDecoration: "underline" }}
          onClick={(e) => {
            e.stopPropagation();
            onViewAll && onViewAll();
          }}
        >
          {trans("View All History")}
        </span>
      </div>

      {expanded && (
        <div style={{ padding: "0 16px 12px" }}>
          {requests.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
              {trans("No previous service requests")}
            </div>
          ) : (
            <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  <th style={{ fontWeight: 600 }}>{trans("Request No.")}</th>
                  <th style={{ fontWeight: 600 }}>{trans("Date")}</th>
                  <th style={{ fontWeight: 600 }}>{trans("Product")}</th>
                  <th style={{ fontWeight: 600 }}>{trans("Complaint")}</th>
                  <th style={{ fontWeight: 600 }}>{trans("Status")}</th>
                  <th style={{ fontWeight: 600, width: "60px" }}>{trans("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((req) => {
                  const statusColor = STATUS_COLORS[req.status] || "default";
                  return (
                    <tr key={req.id}>
                      <td>{req.code || "-"}</td>
                      <td>{formatDate(req.date, lang)}</td>
                      <td>{req.product || "-"}</td>
                      <td>{req.complaint || "-"}</td>
                      <td>
                        <Tag color={statusColor}>
                          {trans(req.status) || req.status}
                        </Tag>
                      </td>
                      <td>
                        <EyeOutlined
                          style={{ cursor: "pointer", color: "#1890ff", fontSize: "16px" }}
                          onClick={() => showDetails("request", req.id)}
                          title={trans("View")}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
